import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { initialGeneralState } from 'store/initial-states';

const general = createSlice({
  name: 'general',
  initialState: initialGeneralState,
  reducers: {
    updateHasMotivationalDelayElapsed: (
      state,
      { payload }: PayloadAction<boolean>
    ) => {
      state.hasMotivationalDelayElapsed = payload;
    },
    updateTabLayoutActiveTab: (state, { payload }) => {
      state.tabLayout.activeTab = payload;
    },
    updateTabLayoutTitles: (state, { payload }: PayloadAction<string[]>) => {
      state.tabLayout.titles = payload;
    },
    setApiRateLimitedUntil: (
      state,
      { payload }: PayloadAction<number | null>
    ) => {
      state.apiRateLimitedUntil = payload;
    },
    clearApiRateLimitedUntil: (state) => {
      state.apiRateLimitedUntil = null;
    },
    setHasDataLoadFailed: (
      state,
      { payload }: PayloadAction<boolean>
    ) => {
      state.hasDataLoadFailed = payload;
    },
    setIsOffline: (state, { payload }: PayloadAction<boolean>) => {
      state.isOffline = payload;
    }
  }
});

export const {
  updateTabLayoutActiveTab,
  updateTabLayoutTitles,
  updateHasMotivationalDelayElapsed,
  setApiRateLimitedUntil,
  clearApiRateLimitedUntil,
  setHasDataLoadFailed,
  setIsOffline
} = general.actions;
export default general.reducer;
